<div class="cv-input cv-input-component" [ngClass]="'display-'+displayMode">
	<label *ngIf="label && label.length > 0" for="{{inputId}}">
		{{label}} <span class="required-text" *ngIf="required">*</span>
	</label>
	<input class="cv-input-text item-value {{className}}"
				 #inputElement
				 [style.display]="type === 'textarea' ? 'none' : ''"
				 [ngClass]="{ 'cv-input--valid': valid, 'input-invalid': (!isValid() || !valid) }"
				 [attr.id]="inputId"
				 [attr.disabled]="disabled ? 'disabled' : null"
				 [attr.type]="type"
				 [attr.max]="type === 'number' ? max : null"
				 [attr.maxlength]="maxlength"
				 [attr.min]="type === 'number' ? min : null"
				 [attr.minlength]="minlength"
				 [attr.name]="name"
				 [attr.pattern]="pattern !== '' ? pattern : null"
				 [attr.placeholder]="placeholder"
				 [attr.readonly]="readonly ? 'readonly' : null"
				 [attr.required]="required ? 'required' : null"
				 [(ngModel)]="value"
				 (change)="onChange($event)"
				 (blur)="onBlur($event)"
				 (focus)="onFocus($event)"
				 (keyup)="onKeyup($event)"
				 (search)="onSearch($event)"
				 (click)="onClick()"
	/>
	<textarea *ngIf="type === 'textarea'"
						class="cv-input-text is-text-area item-value"
						#textAreaElement
						[ngClass]="{ 'cv-input--valid': valid, 'input-invalid': (!isValid() || !valid) }"
						[attr.id]="inputId"
						[attr.disabled]="disabled ? 'disabled' : null"
						[attr.maxlength]="maxlength"
						[attr.minlength]="minlength"
						[attr.name]="name"
						[attr.placeholder]="placeholder"
						[attr.readonly]="readonly ? 'readonly' : null"
						[attr.required]="required ? 'required' : null"
						[rows]="rows"
						[(ngModel)]="value"
						(change)="onChange($event)"
						(blur)="onBlur($event)"
						(focus)="onFocus($event)"
						(keyup)="onKeyup($event)">
	</textarea>

	<span class="cv-test action-clear" (click)="clearValue()"></span>
</div>
